import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/client/lib/page";
import { LandingPage } from "@/client/modules/site/landing-page";

/** Site público (ou só a porta de login, com `landingVitrine` desligada). */
export const Route = createFileRoute("/")({
  head: () => pageHead(),
  component: LandingPage,
});
